// removed by extract-text-webpack-plugin
module.exports = {"content":"src-styles----post-summary-module---content---22PCM","post":"src-styles----post-summary-module---post---1hnAZ","title":"src-styles----post-summary-module---title---1uA1G","image":"src-styles----post-summary-module---image---ltrTv"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/post-summary.module.scss
// module id = 102
// module chunks = 35783957827783